import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    try {
      window.dispatchEvent(new CustomEvent("app-error", { detail: { message: error && error.message, stack: info && info.componentStack } }));
    } catch {}
  }

  handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FAF9F6", padding: 24 }}>
          <div style={{ maxWidth: 420, textAlign: "center" }}>
            <div style={{ width: 72, height: 72, margin: "0 auto", borderRadius: "50%", background: "#050706", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img src="/theuniversaltree-logo.jpeg" alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </div>
            <h1 style={{ fontFamily: "'Inter',sans-serif", fontSize: 20, fontWeight: 600, color: "#1A1D1A", marginTop: 16 }}>Something went wrong</h1>
            <p style={{ color: "#646964", fontSize: 14, marginTop: 8 }}>An unexpected error occurred. Try reloading the page.</p>
            <button onClick={this.handleReload} style={{ marginTop: 16, background: "#1C4532", color: "#fff", border: "none", borderRadius: 10, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
